import React, { ChangeEvent, InputHTMLAttributes, DetailedHTMLProps } from 'react'
import styles from './CustomRadio.module.css'

type DefaultRadioPropsType = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

type CustomRadioPropsType = DefaultRadioPropsType & {
  options?: any[]
  column?: boolean
  onChangeOption?: (option: any) => void
}

const CustomRadio: React.FC<CustomRadioPropsType> = ({
  name,
  options,
  value,
  onChange,
  onChangeOption,
  column,
  ...restProps
}) => {
  const onChangeCallback = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e)
    onChangeOption && onChangeOption(e.currentTarget.value)
  }

  const mappedOptions: any[] = options
    ? options.map((o, i) => (
        <label style={{ fontSize: 14 }} className={styles.radioLabel} key={`${name}-${i}`}>
          <input
            type='radio'
            name={name}
            checked={o === value}
            value={o}
            onChange={onChangeCallback}
            className={styles.radioInput}
            {...restProps}
          />
          <span className={styles.customRadio} />
          {o}
        </label>
      ))
    : []

  return (
    <div
      style={{
        flexDirection: column ? 'column' : 'row',
        gap: column ? 24 : 16,
      }}
      className={styles.radioGroup}
    >
      {mappedOptions}
    </div>
  )
}

export default CustomRadio
